import { css } from "lit";
import { customElement } from "lit/decorators.js";
import { BasicButton } from "./BasicButton.js";

@customElement("warning-button")
class WarningButton extends BasicButton {
	static readonly styles = [
		BasicButton.styles,
		css`
            button {
                background: var(--color-lemon);
                color: black;
            }
            
            button:hover:not(:disabled) {
                background: var(--color-sand);
                box-shadow: 0 4px 15px rgba(242, 237, 120, 0.3);
                color: black;
            }
        `
	];
}

export default WarningButton;